module.exports = __webpack_public_path__ + "img/offer.fc171cb1.svg";